import { AxiosResponse } from 'axios';
import { HomeResponse } from '../@types/home';
import { PermissionsData } from '../interfaces/permissions';
import { apinewforms, apisiseci } from './api';
import { RequestsProps } from '../@types/requests';

export const allFluxos = (
  page: number,
  search?: string,
  active?: string,
  filtro_ativo?: boolean,
  publico_especifico?: string,
  orgao?: string,
  servico_slug?: string,
  titulo?: string,
  modelo?: string,
  ativo?: boolean,
  status?: string,
  data?: string
): Promise<AxiosResponse> => {
  let params = {
    ativo: active,
    search: search === '' ? undefined : search,
    publico_especifico: publico_especifico,
    titulo: titulo,
    filtro_ativo: filtro_ativo,
    status: status,
    orgao__slug: orgao,
    servico_slug: servico_slug,
    modelo: modelo,
    page: page,
    data: data,
  };

  Object.keys(params).forEach(
    (key) => params[key] === undefined && delete params[key]
  );

  return apinewforms.get(`/flow/fluxo-apagar/`, {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
  });
};

export const getFluxo = (slug_fluxo: string): Promise<AxiosResponse> =>
  apinewforms.get(`/flow/fluxo-apagar/${slug_fluxo}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
  });

export const createFluxo = (params: {
  titulo: string;
  descricao: string;
  servico_slug: string;
  ativo: boolean;
  orgao: number;
  modelo: boolean;
  automatico: boolean;
  terceiros: boolean;
  servico_publico_especifico?: string;
  tempo_resposta_solicitado?: string;
  tempo_resposta_restituido?: string;
}): Promise<AxiosResponse> =>
  apinewforms.post(`/flow/fluxo-apagar/`, params, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
  });

export const updateFluxo = (
  slug_fluxo: string,
  titulo: string,
  descricao: string,
  servico_slug: string,
  ativo: boolean,
  orgao: number,
  modelo: boolean,
  automatico: boolean,
  terceiros: boolean,
  servico_publico_especifico?: string,
  tempo_resposta_solicitado?: string,
  tempo_resposta_restituido?: string
): Promise<AxiosResponse> =>
  apinewforms.put(
    `/flow/fluxo-apagar/${slug_fluxo}/`,
    {
      slug: slug_fluxo,
      titulo,
      descricao,
      servico_slug,
      ativo,
      orgao,
      modelo,
      automatico,
      terceiros,
      servico_publico_especifico,
      tempo_resposta_solicitado,
      tempo_resposta_restituido,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
      },
    }
  );

export const getDataHome = (token): Promise<AxiosResponse<HomeResponse>> =>
  apinewforms.get(`/flow/home`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getMyPermissions = (
  token
): Promise<AxiosResponse<PermissionsData>> =>
  apinewforms.get(`/core/my-permissions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const postDocumentForm = (
  flow: string,
  cabecalho: string,
  conteudo: string,
  assunto: string,
  tipo: string,
  conteudo_editavel: boolean,
  sistema_assina: boolean,
  usuario_assina: boolean
): Promise<AxiosResponse> =>
  apinewforms.post(
    '/flow/formato-documento/',
    {
      flow,
      cabecalho,
      conteudo,
      assunto,
      tipo,
      conteudo_editavel,
      sistema_assina,
      usuario_assina,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
      },
    }
  );

export const getDocumentForm = (flow_slug: string): Promise<AxiosResponse> =>
  apinewforms.get(`/flow/formato-documento/?flow_id=${flow_slug}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
  });

export const getDocumentFormById = (
  flow_slug: string,
  document_id: string
): Promise<AxiosResponse> =>
  apinewforms.get(
    `/flow/formato-documento/${document_id}/?flow_id=${flow_slug}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
      },
    }
  );

export const putDocumentForm = (
  document_id: string,
  flow_slug: string,
  cabecalho_id: string,
  assunto: string,
  conteudo: string,
  tipo: string,
  conteudo_editavel: boolean,
  sistema_assina: boolean,
  usuario_assina: boolean,
  ativo: boolean
): Promise<AxiosResponse> =>
  apinewforms.put(
    `/flow/formato-documento/${document_id}/?flow_id=${flow_slug}`,
    {
      id: document_id,
      flow: flow_slug,
      assunto,
      cabecalho: cabecalho_id,
      conteudo,
      tipo,
      conteudo_editavel,
      sistema_assina,
      usuario_assina,
      ativo,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
      },
    }
  );

export const getTramiteOrgan = (identificador: string, token: string) =>
  apinewforms.get(
    `/flow/tramitacao-pendente?identificador_solicitacao=${identificador}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const postTramite = (
  orgao: number,
  status: string,
  descricao: string,
  identificador: string,
  token: string,
  tramitacao_id: string,
  setor?: string,
  internalComment?: string
) =>
  apinewforms.post(
    '/flow/tramitar-solicitacao',
    {
      orgao,
      status,
      descricao,
      identificador,
      tramitacao_id,
      setor,
      comentario_interno: internalComment,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const getReportsDataXlsxFlow = (filter: {
  page?: number;
  status?: string;
  modelo?: boolean;
  servico_slug?: string;
  orgao?: string;
  cpf?: string;
  data_inicio?: string;
  data_fim?: string;
  filtro_ativo?: boolean;
  search?: string;
  atendente?: string;
  setor?: string;
  data?: string;
  protocolo?: string;
}): Promise<AxiosResponse<RequestsProps>> => {
  const { orgao, setor, atendente, ...restFilter } = filter;

  let params: {
    orgao__slug: string;
    status: string;
    protocolo: string;
    modelo: string;
    page?: number;
    servico_slug?: string;
    cpf?: string;
    data_inicio?: string;
    data_fim?: string;
    filtro_ativo?: boolean;
    search?: string;
    data?: string;
  } = {
    ...restFilter,
    orgao__slug: orgao,
    status: filter.status,
    protocolo: filter.protocolo,
    modelo: String(filter.modelo),
  };

  params = Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== '' && value !== null && value !== undefined
    )
  ) as typeof params;

  return apinewforms.get(`/flow/relatorios-xlsx/fluxos`, {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
  });
};

export const getReportsDataCsvFlow = (filter: {
  page?: number;
  status?: string;
  modelo?: boolean;
  servico_slug?: string;
  orgao?: string;
  cpf?: string;
  data_inicio?: string;
  data_fim?: string;
  filtro_ativo?: boolean;
  search?: string;
  protocolo?: string;
  data?: string;
}): Promise<AxiosResponse<Blob>> => {
  const params = {
    page: filter.page,
    status: filter.status,
    modelo: filter.modelo,
    servico_slug: filter.servico_slug,
    orgao__slug: filter.orgao,
    cpf: filter.cpf,
    data_inicio: filter.data_inicio,
    data_fim: filter.data_fim,
    filtro_ativo: filter.filtro_ativo,
    search: filter.search,
    data: filter.data,
    protocolo: filter.protocolo,
  };

  return apinewforms.get(`/flow/relatorios-csv/fluxos`, {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
  });
};

export const getReportsDataPdfFlow = (filter: {
  page?: number;
  status?: string;
  modelo?: boolean;
  servico_slug?: string;
  orgao?: string;
  cpf?: string;
  data_inicio?: string;
  filtro_ativo?: boolean;
  data_fim?: string;
  search?: string;
  protocolo?: string;
  data?: string;
}): Promise<AxiosResponse<Blob>> => {
  const params = {
    page: filter.page,
    status: filter.status,
    modelo: filter.modelo,
    servico_slug: filter.servico_slug,
    orgao__slug: filter.orgao,
    cpf: filter.cpf,
    data_inicio: filter.data_inicio,
    data_fim: filter.data_fim,
    search: filter.search,
    data: filter.data,
    protocolo: filter.protocolo,
    filtro_ativo: filter.filtro_ativo,
  };

  const isEmptyOrNullishArray = (arr) => {
    if (!Array.isArray(arr)) return false;
    return arr.every(
      (item) => item === null || item === undefined || item === ''
    );
  };

  Object.keys(params).forEach((key) => {
    if (
      params[key] === null ||
      params[key] === undefined ||
      params[key] === '' ||
      isEmptyOrNullishArray(params[key])
    ) {
      delete params[key];
    }
  });

  return apinewforms.get(`/flow/relatorios-pdf/fluxos`, {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('gov_access_token')}`,
    },
  });
};

export const duplicateFlow = (
  flow: string,
  titulo: string,
  orgao: number,
  servico: string,
  ativo: boolean,
  descricao: string,
  tokenSSO: string
) =>
  apinewforms.post(
    '/flow/duplicar/',
    {
      flow,
      titulo,
      orgao,
      servico,
      ativo,
      descricao,
    },
    {
      headers: {
        Authorization: `Bearer ${tokenSSO}`,
      },
    }
  );

export const checkTask = (task_id: string, tokenSSO: string) =>
  apinewforms.post(
    '/flow/checar-task/',
    {
      task_id,
    },
    {
      headers: {
        Authorization: `Bearer ${tokenSSO}`,
      },
    }
  );

export const getSevicesToOrgans = (organ_slug: string) =>
  apisiseci.get(`/cms/servicos/?orgao_slug=${organ_slug}`);

export const getAllServices = (organ_slug: string, all?: boolean, integrado_form_flow?: boolean) => {
  if (all) {
    return apisiseci.get(
      `/cms/serv_filter/`,
      {
        params: {
          orgao_slug: organ_slug,
          ativo: true,
          integrado_form_flow: !integrado_form_flow
        }
      }
    );
  }

  return apisiseci.get(`/cms/serv_filter/?orgao_slug=${organ_slug}`);
};

export const getServicesAll = () =>
  apisiseci.get(`/cms/serv_filter/?send_all=true`);

export const getServiceTerms = (
  tokenSSO: string,
  flow_id: string,
  page?: number
) =>
  apinewforms.get(`/flow/termo-fluxo/`, {
    params: {
      flow: flow_id,
      page,
    },
    headers: {
      Authorization: `Bearer ${tokenSSO}`,
    },
  });

export const getServiceTermsById = (
  tokenSSO: string,
  flow_id: string,
  id: string
) =>
  apinewforms.get(`/flow/termo-fluxo/${id}`, {
    params: {
      flow: flow_id,
    },
    headers: {
      Authorization: `Bearer ${tokenSSO}`,
    },
  });

export const saveServiceTerms = (
  tokenSSO: string,
  flow_id: string,
  body: {
    titulo: string;
    versao: string;
    texto: string;
  }
) =>
  apinewforms.post(
    `/flow/termo-fluxo/?flow=${flow_id}`,
    {
      ...body,
      flow: flow_id,
    },
    {
      headers: {
        Authorization: `Bearer ${tokenSSO}`,
      },
    }
  );
